import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'revoke-signature',
		path: '/p/:slug/unsign',
		component: loadable(async () => import(/* webpackChunkName: "pages/revoke_signature" */ './index'), {
			exportName: 'RevokeSignature',
			fallback: Loading,
		}),
		// no restricted access as this is done using a dedicated token
		frame: true,
		ssr: {
			enabled: true,
			// this is a mutation page so we want to avoid navigating to it using react-router
			isolated: true,
			seo: false,
		},
	},
];
